<div>
  <span
    class="instructor-certificate badge badge-light"
    [style.backgroundColor]="certificate.color"
  >
    {{ certificate.name }}
  </span>
</div>
